import { react2angular } from "react2angular";
import { loginModule } from "../login-module";
import { VerifyEmailPhoneContainer } from "./VerifyEmailPhoneContainer";
import { connectWithStore } from "connectWithStore";
import { store } from "redux/store/store";

loginModule.component('verifyEmailPhone', react2angular(
        connectWithStore(store, VerifyEmailPhoneContainer),
        ['email', 'phone', 'goTo']
    )
)